import "../../../styles/home1.css";

export default function ToBePacked() {
  return (

    <div className="card shadow-sm border-0 h-100">

      <div className="card-body d-flex justify-content-between align-items-center p-3">

        <div>
          <p
            className="text-muted text-uppercase small mb-1 fw-bold"
            style={{ fontSize: "0.75rem" }}
          >
            TO BE PACKED
          </p>

          <h5 className="fw-bold mb-0">657 Unit</h5>
        </div>

        <div className="fs-4 text-primary opacity-50">
          🕴️
        </div>

      </div>

    </div>

  );
}